/**
 * Created by shanie on 11/3/16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import { Button } from 'dibs-elements/exports/Button';

// Helpers
import { copy, tabs, deviceTypes } from '../../constants';

// Styles
import styles from './styles/BasicHeader.scss';

const BasicHeader = props => {
    const buttonSize = props.isMobile ? 'medium' : 'large';
    return (
        <div className={styles.container}>
            <div className={styles.title} data-tn="title">
                {props.title}
                {props.totalItems >= 0 && (
                    <span className={styles.count} data-tn="total-items">
                        ({props.totalItems})
                    </span>
                )}
            </div>
            {props.tab === tabs.FOLDERS && (
                <Button
                    size={buttonSize}
                    className={`${styles.button} favorites`}
                    dataTn="create-folder-button"
                    disabled={props.selecting}
                    onClick={props.onClick}
                >
                    {copy.bulkActions.CREATE_FOLDER}
                </Button>
            )}
            {props.tab === tabs.PROJECTS && (
                <Button
                    size={buttonSize}
                    className={`${styles.button} favorites`}
                    dataTn="create-project-button-header"
                    disabled={props.selecting}
                    onClick={props.onClick}
                >
                    {copy.bulkActions.CREATE_PROJECT}
                </Button>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    selecting: state.favorites.uiState.selecting,
    tab: state.favorites.uiState.tab,
    isMobile: state.favorites.uiState.deviceType === deviceTypes.MOBILE,
});

BasicHeader.propTypes = {
    makePublic: PropTypes.func,
    onClick: PropTypes.func,
    onSwitch: PropTypes.func,
    selecting: PropTypes.bool,
    isMobile: PropTypes.bool,
    tab: PropTypes.string,
    title: PropTypes.node,
    totalItems: PropTypes.number,
};

export default connect(mapStateToProps)(BasicHeader);
